import MuiAppBar from '@mui/material/AppBar';
import { styled } from '@mui/material/styles';

export const AppBar = styled(MuiAppBar)(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        zIndex: theme.zIndex.drawer + 1,
    },
}));
